@if (banner$ | async; as banner) {
  <sd-generic-link [url]="banner.link" (click)="onBannerClick(banner)">
    <img [ngSrc]="banner.url" [alt]="banner.altText" fill />
  </sd-generic-link>
} @else if (isLoading$ | async) {
  <div class="banner-skeleton sd-group-skeleton-gradient-wave">
    <div class="sd-skeleton"></div>
  </div>
}
